export default __webpack_public_path__ + "static/media/leggings_of_the_farseeker.63643537.jpg";